import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';

import { WebToAppBanner } from './WebToAppBanner';
import { trackBannerShow, trackDownloadAppClick } from './tracking';
import { EAppService } from '../../../types/appService';

export function WebToAppBannerContainer() {
  const handleDownloadAppClick = (appService: EAppService) => {
    trackDownloadAppClick({ appService });
  };

  return (
    <ActionAfterViewObserver callback={trackBannerShow} percentVisible={0.5} triggerOnce callbackDelay={1000}>
      <WebToAppBanner onClick={handleDownloadAppClick} />
    </ActionAfterViewObserver>
  );
}
